<template>
    <div id="mainbody"  :style="{maxWidth:screenWidth}">
        <h3>RMA Form</h3>
        <el-form :model="rmaForm" :rules="rules" ref="rmaFormRef" >




            <el-collapse v-model="activeNames" >
             <el-row>
                 <el-col :span="15">
                     <el-collapse-item  title="Customer Information" name="1" class="customer-account-header" >
                         <table class="customer-account">
                             <tr>
                                 <td>RMA Applicant<span class="bixu">*</span></td>
                                 <td><el-input  v-model="rmaForm.application"  ></el-input></td>
                                 <td>Phone<span class="bixu">*</span></td>
                                 <td><el-input   v-model="rmaForm.phone" ></el-input></td>
                             </tr>
                             <tr>
                                 <td>Company<span class="bixu">*</span></td>
                                 <td><el-input   v-model="rmaForm.company" ></el-input></td>
                                 <td>E-mail address<span class="bixu">*</span></td>
                                 <td><el-input   v-model="rmaForm.email" ></el-input></td>
                             </tr>
                             <tr>
                                 <td>Country<span class="bixu">*</span></td>
                                 <td><el-input   v-model="rmaForm.country" ></el-input></td>
                                 <td>Code<span class="bixu">*</span></td>
                                 <td><el-input   v-model="rmaForm.code" ></el-input></td>
                             </tr>
                         </table>
                     </el-collapse-item>
                 </el-col>
                 <el-col :span="9">
                     <el-collapse-item  title="RMA Status" name="2" class="rma-status-header">
                         <table class="customer-account">
                             <tr>
                                 <td>RMA Submit Date</td>
                                 <td><el-input disabled  v-model="rmaForm.create_time" ></el-input></td>
                             </tr>
                             <tr>
                                 <td>*RMA Status</td>
                                 <td>
                                     <el-select disabled v-model="rmaForm.status" placeholder="please choose">
                                         <el-option label="RMA Reported" value=0> </el-option>
                                         <el-option label="BTI Wireless Response" value=1> </el-option>
                                         <el-option label="Return to BTI Wireless" value=2> </el-option>
                                         <el-option label="Analysis" value=3> </el-option>
                                         <el-option label="Repair" value=4> </el-option>
                                         <el-option label="Return to Customer" value=5> </el-option>


                                     </el-select>

                                 </td>
                             </tr>
                             <tr>
                                 <td>RMA Closed Date</td>
                                 <td>
                                     <el-date-picker
                                             disabled
                                             v-model="rmaForm.close_date"
                                             type="date"
                                             value-format="yyyy-MM-dd"
                                             placeholder="select date">
                                     </el-date-picker>

                                 </td>
                             </tr>
                         </table>
                     </el-collapse-item>
                 </el-col>


             </el-row>

                <el-row :gutter="20" >
                    <el-col :span="24">

                        <el-collapse-item title="RMA Submission Detail (by Customer)" name="5" class="userinput">
                            <table class="customer-account product-details">
                                <tr>
                                    <th class="bgred">Product Name <span class="bixu">*</span></th>
                                    <th class="bgred">Serial Number <span class="bixu">*</span></th>
                                    <th class="bgred">Fault Category</th>
                                    <th class="bgred" width="25%">Fault Description <span class="bixu">*</span></th>
                                    <th class="bgred">File Upload</th>
                                    <th class="bgred">Option</th>
                                </tr>

                                <tr v-for="(itemp,index) in rmaForm.product" >
                                    <td><el-input   v-model="itemp.product_name" ></el-input></td>
                                    <td><el-input   v-model="itemp.serial_number" ></el-input></td>
                                    <td><el-select  v-model="itemp.faulty_category" placeholder="please choose">
                                        <el-option
                                                v-for="item in setForm.faulty_category"
                                                :label="item"
                                                :value="item">
                                        </el-option>

                                    </el-select>
                                    </td>
                                    <td><el-input   v-model="itemp.faulty_description" type="textarea" :autosize="{ minRows: 1, maxRows: 10}"></el-input></td>
                                    <td>
                                        <el-upload
                                                class="upload-demo"
                                                :action="geturl()"
                                                :headers="myHeaders"
                                                :limit="1"
                                                :on-remove="( file, fileList)=>handleRemove( file, fileList,index)"
                                                :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,index)"
                                                :before-remove="beforeRemove"
                                                :multiple=true
                                                :on-exceed="handleExceed"

                                                :file-list="fileList">
                                            <el-button   size="small" type="primary" ><i class="el-icon-upload"></i></el-button>
                                        </el-upload>

                                    </td>
                                    <td> <i class="el-icon-remove"  @click="deleteItem(index)"  v-if="addtrue"></i>
                                        <i class="el-icon-circle-plus" @click="addinput()" ></i></td>
                                </tr>

                            </table>
                        </el-collapse-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20" >
                    <el-col :span="12">

                        <el-collapse-item title="Shipping Details" name="3" class="userinput">
                            <table class="customer-account product-details">
                                <tr>
                                    <th>Address <span class="bixu">*</span></th>
                                    <th>Contact Name <span class="bixu">*</span></th>
                                    <th>Phone Number <span class="bixu">*</span></th>
                                </tr>
                                <tr>
                                    <td><el-input v-model="rmaForm.rma_address" ></el-input></td>
                                    <td><el-input   v-model="rmaForm.contact_name" ></el-input></td>
                                    <td><el-input   v-model="rmaForm.phone_number" ></el-input></td>
                                </tr>

                            </table>
                        </el-collapse-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20" >
                    <el-col :span="12">

                        <el-collapse-item title="Customer Information" name="4" class="color-green">
                            <table class="customer-account product-details">
                                <tr>
                                    <th>RMA Number</th>
                                    <th>Items Registered</th>
                                </tr>

                                <tr>
                                    <td><el-input :disabled="role===3"  v-model="rmaForm.rma_number" ></el-input></td>
                                    <td><el-input :disabled="role===3"  v-model="rmaForm.items_registered" ></el-input></td>
                                </tr>

                            </table>
                        </el-collapse-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20" >
                    <el-col :span="24">

                        <el-collapse-item title="RMA Information" name="5" class="color-green">
                            <table class="customer-account product-details">
                                <tr>
                                    <th>RMA Number<span class="bixu">*</span></th>
                                    <th>Product name<span class="bixu">*</span></th>
                                    <th>Serial Number<span class="bixu">*</span></th>
                                    <th>RMA Solution</th>
                                    <th>Information</th>
                                    <th>Requirement</th>
                                    <th>Warranty Status</th>
                                </tr>

                                <tr  v-for="(itemp,index) in rmaForm.product">
                                    <td><el-input  :disabled="role===3" v-model="itemp.rma_number" ></el-input></td>
                                    <td><el-input  :disabled="role===3" v-model="itemp.part_number" ></el-input></td>
                                    <td><el-input  :disabled="role===3" v-model="itemp.serial_number" ></el-input></td>
                                    <td>
                                        <el-select :disabled="role===3"  v-model="itemp.rma_solution" placeholder="please choose">
                                            <el-option
                                                    v-for="item in setForm.rma_solution"
                                                    :label="item"
                                                    :value="item">
                                            </el-option>
                                        </el-select>
                                    </td>
                                    <td><el-input :disabled="role===3"  v-model="itemp.delivery_information" ></el-input></td>
                                    <td><el-input  :disabled="role===3" v-model="itemp.packing_requierment" ></el-input></td>
                                    <td>
                                        <el-select :disabled="role===3" v-model="itemp.warranty_status" placeholder="please choose">
                                            <el-option
                                                    v-for="item in setForm.warranty_status"
                                                    :label="item"
                                                    :value="item">
                                            </el-option>
                                        </el-select>
                                    </td>
                                </tr>

                            </table>
                        </el-collapse-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20" >
                    <el-col :span="24">

                        <el-collapse-item title="Shipping Tracker (Customer→BTI Wireless)" name="6">
                            <table class="customer-account product-details">
                                <tr>
                                    <th>Responsible Party</th>
                                    <th>RMA#s</th>
                                    <th class="bgred">Delivery information</th>
                                    <th class="bgred">Pickup Ready</th>
                                    <th class="bgred">INV&PL</th>
                                    <th class="bgred">tracking#/AWB#</th>
                                    <th>Received Date</th>
                                </tr>

                                <tr  v-for="(itemp,index) in rmaForm.product">
                                    <td> <el-select :disabled="role===3"  v-model="itemp.responsible" placeholder="please choose">
                                        <el-option
                                                v-for="item in setForm.responsible"
                                                :label="item"
                                                :value="item">
                                        </el-option>
                                    </el-select>
                                    </td>
                                    <td><el-input :disabled="role===3"  v-model="itemp.rma_s" ></el-input></td>
                                    <td><el-input disabled  v-model="itemp.user_delivery_information" ></el-input></td>
                                    <td><el-input  disabled v-model="itemp.pickup_ready" ></el-input></td>
                                    <td><el-input  disabled v-model="itemp.inv_pl" ></el-input></td>
                                    <td><el-input  disabled v-model="itemp.tracking" ></el-input></td>
                                    <td>
                                        <el-date-picker
                                                :disabled="role===3"
                                                v-model="itemp.received_date"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="select date">
                                        </el-date-picker>
                                    </td>
                                </tr>

                            </table>
                        </el-collapse-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20" :hidden="role===3" >
                    <el-col :span="24">

                        <el-collapse-item title="FAULT ASSESSMENT & SOLUTION (Internal user Only)" name="7" class="color-red">
                            <table class="customer-account">
                                <tr>
                                    <th>Assessor</th>
                                    <th>Assessment Date</th>
                                    <th>Assessment Result</th>
                                    <!--<th>Possible Cause</th>-->
                                    <th>Parts Replaced</th>
                                    <!--<th>Customer Response</th>-->
                                    <th>Type of Cause</th>
                                </tr>

                                <tr  v-for="(itemp,index) in rmaForm.product">
                                    <td><el-input  :disabled="role===3" v-model="itemp.assessor" ></el-input></td>
                                    <td>
                                        <el-date-picker
                                                :disabled="role===3"
                                                v-model="itemp.assessment_date"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="select date">
                                        </el-date-picker>
                                    </td>
                                    <td><el-input :disabled="role===3"  v-model="itemp.assessment_result" ></el-input></td>
                                    <!--<td><el-input :disabled="role===3"  v-model="itemp.possible_cause" ></el-input></td>-->
                                    <td><el-input :disabled="role===3"  v-model="itemp.parts_replaced" ></el-input></td>
                                    <!--<td><el-input :disabled="role===3"  v-model="itemp.customer_response" ></el-input></td>-->
                                    <td>
                                        <el-select :disabled="role===3" v-model="itemp.type_of_cause" placeholder="please choose">
                                            <el-option
                                                    v-for="item in setForm.type_of_cause"
                                                    :label="item"
                                                    :value="item">
                                            </el-option>

                                        </el-select>
                                    </td>
                                </tr>

                            </table>
                        </el-collapse-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20" >
                    <el-col :span="24">

                        <el-collapse-item title="Progress Update (For Customer Feedback)" name="8">
                            <table class="customer-account product-details">
                                <tr>
                                    <th>Update Date</th>
                                    <!--<th>Update by</th>-->
                                    <th>RMA#</th>
                                    <th>Servicing Record </th>
                                    <th>Corrective Action</th>
                                    <th>Estimated Return Date</th>
                                </tr>

                                <tr  v-for="(itemp,index) in rmaForm.product">
                                    <td>
                                        <el-date-picker
                                                :disabled="role===3"
                                                v-model="itemp.progress_update_user_date"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="select date">
                                        </el-date-picker>
                                    </td>
                                    <!--<td><el-input  :disabled="role===3" v-model="itemp.update_by" ></el-input></td>-->
                                    <td><el-input :disabled="role===3"  v-model="itemp.rma_s" ></el-input></td>
                                    <td><el-input  :disabled="role===3" v-model="itemp.servicing_record" ></el-input></td>
                                    <td><el-input  :disabled="role===3" v-model="itemp.corrective_action" ></el-input></td>
                                    <td>
                                        <el-date-picker
                                                :disabled="role===3"
                                                v-model="itemp.estimated_return_date"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="select date">
                                        </el-date-picker>
                                    </td>
                                </tr>

                            </table>
                        </el-collapse-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20" >
                    <el-col :span="24">

                        <el-collapse-item title="Shipping Tracker (BTI Wireless→Customer)" name="9">
                            <table class="customer-account product-details">
                                <tr>
                                    <th>Responsible Party</th>
                                    <th>RMA Number(s)</th>
                                    <th class="bgred">Delivery information</th>
                                    <th>Pickup Ready</th>
                                    <th>Delivery Docs</th>
                                    <th>Tracking#/AWB</th>
                                    <th class="bgred">Received Date</th>
                                </tr>

                                <tr  v-for="(itemp,index) in rmaForm.product">
                                    <td><el-input :disabled="role===3"  v-model="itemp.responsible2" ></el-input></td>
                                    <td><el-input :disabled="role===3"  v-model="itemp.serail_no" ></el-input></td>
                                    <td><el-input disabled  v-model="itemp.user_delivery_information2" ></el-input></td>
                                    <td><el-input  :disabled="role===3" v-model="itemp.pickup_ready2" ></el-input></td>
                                    <td>
                                        <el-upload
                                                :disabled="role===3"
                                                v-if="itemp.tag"
                                                class="upload-demo"
                                                :action="geturl()"
                                                :headers="myHeaders"
                                                :limit="1"
                                                :on-remove="( file, fileList)=>handleRemove( file, fileList,index)"
                                                :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,index)"
                                                :before-remove="beforeRemove"
                                                :multiple=true
                                                :on-exceed="handleExceed"
                                                :file-list="fileList">
                                            <el-button    size="small" type="primary" ><i class="el-icon-upload"></i></el-button>
                                        </el-upload>
                                        <el-button   size="small" @click="downloaddocs('delivery_docs',itemp.id)"><i class="el-icon-download"></i></el-button>
                                    </td>
                                    <td><el-input :disabled="role===3"  v-model="itemp.tracking2" ></el-input></td>
                                    <td>
                                        <el-date-picker
                                                disabled
                                                v-model="itemp.user_received_date"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="select date">
                                        </el-date-picker>
                                    </td>
                                </tr>

                            </table>
                        </el-collapse-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20" >
                    <el-col :span="16">

                        <el-collapse-item title="Correspondence Register" name="10">
                            <table class="customer-account product-details">
                                <tr>
                                    <th>Entry Date</th>
                                    <th>Entered by</th>
                                    <th>Questions</th>
                                    <th>Response</th>
                                    <th>What is this field for?</th>
                                </tr>

                                <tr  v-for="(itemp,index) in rmaForm.product">
                                    <td>
                                        <el-date-picker
                                                :disabled="role===3"
                                                v-model="itemp.entry_date"
                                                type="date"
                                                value-format="yyyy-MM-dd"
                                                placeholder="select date">
                                        </el-date-picker>
                                    </td>
                                    <td><el-input :disabled="role===3"  v-model="itemp.entered_by" ></el-input></td>
                                    <td><el-input :disabled="role===3"  v-model="itemp.questions" ></el-input></td>
                                    <td><el-input :disabled="role===3"  v-model="itemp.response" ></el-input></td>
                                    <td><el-input  :disabled="role===3" v-model="itemp.customer_accept" ></el-input></td>
                                </tr>

                            </table>
                        </el-collapse-item>
                    </el-col>
                </el-row>
        </el-collapse>
        </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :disabled="submiting" @click="add">SUBMIT</el-button>
            </span>

    </div>
</template>

<script>
    var token =  localStorage.getItem('token')
    import autosize from 'autosize';
    export default {
        name: "rmaAdd.vue",
        data(){
            return{
                screenWidth: document.body.clientWidth-310 + "px",
                isdowning:false,
                rmaForm:{
                    status:"creating",
                    product:[{faulty_product:'',serial_number:'',faulty_category:'',isload:true,file_upload:[],delivery_docs:[]}],

                    name:"",
                    email:"",
                    phone:"",
                    country:"",
                    company:"",
                },
                submiting:false,
                addtrue:false,
                addlable:["Option"],
                activeNames:["1","2","3","4","5","6","7","8","9","10"],
                setForm:{},
                temp:"",
                role:"",
                fileList:[],
                myHeaders: {token: token},
                link:[],
                rules:{
                },

            }

        },
         created() {
             this.setForm =  JSON.parse(localStorage.getItem('setform'));
             this.getInfo();
             this.role=parseInt(localStorage.getItem("role"));


        },

        methods:{
            async add() {
                console.log(this.rmaForm)
                this.$refs.rmaFormRef.validate(async valid => {
                    if(!this.rmaForm.application){
                        this.$message.error('Please fill out RMA applicant!!');
                        return false;
                    }
                    if(!this.rmaForm.company){
                        this.$message.error('Please fill out company!!');
                        return false;
                    }
                    if(!this.rmaForm.country){
                        this.$message.error('Please fill out Country!!');
                        return false;
                    }
                    if(!this.rmaForm.email){
                        this.$message.error('Please fill out email!!');
                        return false;
                    }
                    if(!this.rmaForm.phone){
                        this.$message.error('Please fill out phone!!');
                        return false;
                    }
                    if(!this.rmaForm.code){
                        this.$message.error('Please fill out code!!');
                        return false;
                    }


                    for(let i=0;i<this.rmaForm.product.length;i++){
                        if(!this.rmaForm.product[i].product_name){
                            this.$message.error('Please fill out Product Name!!');
                            return false;
                        }
                        if(!this.rmaForm.product[i].serial_number ){
                            this.$message.error('Please fill out Serial Number !!');
                            return false;
                        }
                        if(!this.rmaForm.product[i].faulty_description){
                            this.$message.error('Please fill out Fault Description!!');
                            return false;
                        }
                    }


                        if(!this.rmaForm.rma_address){
                            this.$message.error('Please fill out Address!!');
                            return false;
                        }
                        if(!this.rmaForm.contact_name){
                            this.$message.error('Please fill Contact Name!!');
                            return false;
                        }
                        if(!this.rmaForm.phone_number){
                            this.$message.error('Please fill Phone Number!!');
                            return false;
                        }



                    if (!valid) {
                        console.log('error submit!!');
                        return false;
                    }
                    this.submiting=true
                    const result=await this.$http.post("rma/add",this.rmaForm);
                    if (result.data.error_code!==0){
                        this.$message.error(result.data.msg);
                    }else {
                        this.$message.success(result.data.msg);
                        this.$router.push('/rmaList');
                        await this.$http.post("rma/addsend",result.data.data);
                        await this.$http.post("rma/addsend2",result.data.data);
                    }
                });
            },
            async getInfo(){
                const result=await this.$http.get("user/infoself");
                if (result.data.error_code!==0){
                    this.$message.error(result.data.msg);
                }else {
                    console.log(result.data.data.name)


                    this.rmaForm.name=result.data.data.name;
                    this.rmaForm.email=result.data.data.email;
                    this.rmaForm.phone=result.data.data.phone;
                    this.rmaForm.country=result.data.data.country;
                    this.rmaForm.company=result.data.data.company;
                    this.rmaForm.code=result.data.data.id;

                    this.rmaForm.application=result.data.data.firstname + result.data.data.lastname ;

                    this.rmaForm = JSON.parse(JSON.stringify(this.rmaForm));
                }
            },
            async handleRemove(file, fileList,index) {

                this.rmaForm.product[index].file_upload.splice(this.rmaForm.product[index].file_upload.indexOf(file.response.data),1);

            },
            handleSuccess(response, file, fileList,index){
                if(response.error_code !== 0){
                    this.$message.error(response.msg);

                }else {
                    this.rmaForm.product[index].file_upload.push(response.data);

                }

            },
            handlePreview(file) {
                console.log(file);
            },
            handleExceed(files, fileList) {
                this.$message.warning(`Limit to select 1 files, this time selected ${files.length} Files, selected ${files.length + fileList.length} files selected`);
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`remove ${ file.name }？`);
            },
            addinput(){
                this.rmaForm.product.push({faulty_product:' ',serial_number:' ',faulty_category:' ',isload:true,file_upload:[],delivery_docs:[]});
                if(this.rmaForm.product.length===1){
                    this.addtrue=false;
                }else {
                    this.addtrue=true;
                }
            },
            geturl(){
                return this.$http.defaults.baseURL + "file/upload"
            },
            deleteItem(index){

                this.rmaForm.product.splice(index,1);
                if(this.rmaForm.product.length===1){
                    this.addtrue=false;
                }else {
                    this.addtrue=true;
                }
            }
        },
        updated : function(){
            this.$nextTick(function(){
                autosize(document.querySelectorAll('textarea'));
            })
        }
    }
</script>

<style lang="less">

    .el-table{

    }
    .el-breadcrumb{
        padding-top: 10px;
    }
    .el-card{
        margin-bottom: 5px;
    }
    .el-table{
        margin-bottom: 5px;
    }
    .el-table-column{
        padding-left: 10px;
    }
    .el-form{
        width: 100%;
    }
    .el-select{
        width: 100%;
    }
    .option2 i{
        margin: 0 7px;
        font-size: 24px;
        color: #008080;
    }

    #mainbody{
        .customer-account td{
            text-align: right;
            padding: 1px;
            background-color: #f1f1f1;
            border: 1px solid #9b9598;
        }
        .customer-account th{
            text-align: left;
            padding: 1px;
            background-color: #f1f1f1;
            border: 1px solid #9b9598;
        }
        .product-details td{
            border-left: none;
            border-right: none;
        }
     .el-date-picker{
         width: 100%;
         cursor: pointer;
         .el-input__inner{
            cursor: pointer;
         }



     }
        .el-input__prefix{
            left: 87% !important;

        }
        .el-select /deep/ .el-input__suffix /deep/ .el-input__icon{
            line-height: 20px;
        }
        .product-details{
            textarea{
                padding: 2px;
                height: 25px;
            }
            i{
                font-size: 15px;
            }
            .el-upload{
                float: right;
            }
            .el-upload-list{
                width: 85%;
                float: right;
                ul{
                    padding: 0;
                }
                li{
                    padding: 0;
                    margin: 0;
                }
            }
            button {
                height: 25px;
                padding: 0;
                background-color: #efeff0;
                color: #000000;
                border: none;
            }

        }


        .customer-account {
            width: 100%;
            border-collapse:collapse;
        }
        .customer-account .el-input__inner{
            line-height: 20px;
            height: 30px !important;
            border:none;
            margin: 0;
            padding: 0;
            background-color: #ffffff;
        }
        .customer-account .el-input{
            height: 20px;
            border:none;
            margin: 0;
            padding: 0px;
        }
        .el-collapse-item__header{
            background-color: black;
            color: white;
            height: 30px;
        }
        .color-green{
            .el-collapse-item__header{
                background-color: #33ca01;
                color: black;
            }
        }
        .customer-account-header{
            .el-collapse-item__header{
                // border-radius: 10px 0 0 0;
            }
        }
        .rma-status-header{
            .el-collapse-item__header{
                background-color: #4b83bd;
            }
        }
        .el-date-editor{
            width: 100% !important;
        }
        .el-textarea__inner{
            min-height: 25px !important;
            max-height: 200px !important;
        }
        .el-input__icon{
            line-height: 20px;
            .el-icon-arrow-up{
               position: absolute;
            }
        }

    }
    .app-header-userinfo {
        top:0 !important;
    }
</style>
